module.exports = __webpack_public_path__ + "img/bann.9160bf7a.png";